import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import { OperationStatus } from 'app/services/OperationStatus'

interface INcpersOpState {
  op: OperationStatus,
  results: any
}

interface INcpersOpAction extends IReducerAction {
  type: string,
  ncpers: INcpersOpState
}

const ActionTypes = {

  NCPERS_OP_STARTING: 'ncpers/OP_STARTING',
  NCPERS_OP_COMPLETED: 'ncpers/OP_COMPLETED',
  NCPERS_OP_FAILED: 'ncpers/OP_FAILED'

}

export {
  ActionTypes,
  INcpersOpAction,
  INcpersOpState
}



// WEBPACK FOOTER //
// ./src/app/redux/Customers/ncpers/reducer/index.ts